import React from 'react';
import LoadingWrapper from './loadingWrapper';

// Gets the display name of a JSX component for dev tools
function getComponentDisplayName(Component) {
  return Component.displayName || Component.name || 'Unknown';
}

// WithLoadingContext HOC hides content in favor of loading.
// Normally this should not be used, as loading is provided by containers
export default ({
  className = null,
  fallback = null,
  isLoading = props => props.loading,
} = {}) => (WrappedComponent) => {
  const WithLoadingContext = (props) => {
    const loading = isLoading(props);

    return (
      <LoadingWrapper
        className={className}
        loading={loading}
        message={fallback}
      >
        <WrappedComponent {...props} />
      </LoadingWrapper>
    );
  };

  WithLoadingContext.displayName = `WithLoadingContext(${getComponentDisplayName(WrappedComponent)})`;

  return WithLoadingContext;
};
